module.exports = ".my-select{\n  width: 100px;\n}\n"